/**
 * Abstractions to manage user tracking uniformly across our web applications.
 * <br>
 * <br>A default implementation for Segment is provided.
 *
 * @packageDocumentation
 */
export { SegmentAnalyticsProvider } from "./segment/SegmentAnalyticsProvider";
export { BaseTrackingEventHandler } from "./core/module/BaseTrackingEventHandler";
export { BaseTrackingEventSegmentHandler } from "./segment/BaseTrackingEventSegmentHandler";
export { CommonTrackingEvents } from "./core/model/CommonTrackingEvents";
export { BaseTrackingEvent } from "./core/model/BaseTrackingEvent";
export { TrackingEventAmbientRegistry } from "./core/TrackingEventAmbientRegistry";
export { TrackingPlugin } from "./core";
export { CoreTrackingModule } from "./core";
export { CoreSegmentModule } from "./segment";
//# sourceMappingURL=index.js.map